import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { slideClasses } from "@/components/collection/overview/styles";
import { getMediaPropsFromMedia } from "@/components/collection/overview/utils";
import { OverviewModuleCarousel } from "../../../OverviewModuleCarousel";
import { TeamModuleSlide } from "../TeamModuleSlide";
import { TeamModuleCarouselFragment } from "./TeamModuleCarousel.fragment";
export function TeamModuleCarousel(t0) {
  const $ = _c(10);
  const {
    team: teamKey
  } = t0;
  let T0;
  let t1;
  let t2;
  let t3;
  if ($[0] !== teamKey) {
    const team = readFragment(TeamModuleCarouselFragment, teamKey);
    T0 = OverviewModuleCarousel;
    t1 = team.description;
    t2 = team.title || "Team";
    t3 = team.sections?.map(_temp);
    $[0] = teamKey;
    $[1] = T0;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    T0 = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== T0 || $[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <T0 description={t1} title={t2}>{t3}</T0>;
    $[5] = T0;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
function _temp(section) {
  if (!section) {
    return null;
  }
  const mediaProps = getMediaPropsFromMedia(section.media?.[0]);
  return <TeamModuleSlide className={slideClasses({
    variant: "team"
  })} key={section.name} {...section} imageUrl={mediaProps?.imageUrl} />;
}